"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoaderEpic = void 0;
var _types = require("./types");
var _reduxObservable = require("redux-observable");
var _operators = require("rxjs/operators");
var _rxjs = require("rxjs");
var _Core = _interopRequireDefault(require("../Core"));
var _types2 = require("../config/types");
var _types3 = require("../game/types");
var _platformService = _interopRequireDefault(require("../../../utils/platformService"));
var _logger = _interopRequireDefault(require("../../../utils/logger"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var LoaderEpic = exports.LoaderEpic = /*#__PURE__*/function () {
  function LoaderEpic() {
    var _this = this;
    _classCallCheck(this, LoaderEpic);
    _defineProperty(this, "started", void 0);
    _defineProperty(this, "pbElement", void 0);
    _defineProperty(this, "check", function () {
      if (!_Core["default"].loader) throw new Error("Loader not registered");
    });
    _defineProperty(this, "loadEpic", function (action$) {
      return action$.pipe((0, _reduxObservable.ofType)(_types.LOAD), (0, _operators.mergeMap)(function (a) {
        _this.check();
        _Core["default"].loader.add(a.payload.file, a.payload.name, a.payload.metadata);
        return _rxjs.EMPTY;
      }));
    });
    _defineProperty(this, "preloadEpic", function (action$) {
      return action$.pipe((0, _reduxObservable.ofType)(_types.PRELOAD, _types.PRELOAD_START), (0, _operators.mergeMap)(function (a) {
        _this.check();
        switch (a.type) {
          case _types.PRELOAD:
            _Core["default"].loader.preloadAdd(a.payload.file, a.payload.name, a.payload.callback, a.payload.callback);
            return _rxjs.EMPTY;
          case _types.PRELOAD_START:
            _Core["default"].loader.preloadStart(a.payload.callback);
            return new _rxjs.Observable(function (observer) {
              _Core["default"].loader.onProgressPreloader(function (e, f) {
                if (e) observer.next({
                  type: _types.PRE_LOADER_PROGRESS,
                  payload: e.progress
                }); // Pass file name.
              });
            });
        }
      }));
    });
    _defineProperty(this, "languageLoading", function (action$, store) {
      return action$.pipe((0, _reduxObservable.ofType)(_types.LANGUAGE_FILE_LOADED), (0, _operators.filter)(function () {
        return store.value.loader.languageFilesLoaded == store.value.loader.languageFiles;
      }), (0, _operators.mapTo)({
        type: _types.LOADED_TRANSLATIONS
      }));
    });
    _defineProperty(this, "startEpic", function (action$, store) {
      return action$.pipe((0, _reduxObservable.ofType)(_types.START_LOADING), (0, _operators.mergeMap)(function () {
        return new _rxjs.Observable(function (observer) {
          _Core["default"].loader.onError(function (e) {
            observer.next({
              type: _types.LOAD_FAILED,
              payload: e.message
            });
          });
          _Core["default"].loader.onProgress(function (e, f) {
            // note we assume that there ALWAYS is a language_{locale} file, ie a game specific. THe shared files wont trigger this.
            // logic to detect if translations has been loaded.
            if (f.metadata.languageFile) {
              observer.next({
                type: _types.LANGUAGE_FILE_LOADED
              });
            }
            if (e) observer.next({
              type: _types.LOADER_PROGRESS,
              payload: e.progress
            }); // Pass file name.
          });
          observer.next({
            type: _types.LOADING_STARTED
          });
          _this.started = new Date().getTime();
          _Core["default"].loader.load(function () {
            var minLoaderTime = store.value.config.minLoaderTime;
            var wait = minLoaderTime - (new Date().getTime() - _this.started);
            setTimeout(function () {
              observer.next({
                type: _types.LOADING_COMPLETED
              });
              observer.complete();
            }, wait);
          });
        });
      }));
    });
    _defineProperty(this, "onProgress", function (action$, store) {
      return action$.pipe((0, _reduxObservable.ofType)(_types.LOADER_PROGRESS, _types.PRE_LOADER_PROGRESS), (0, _operators.mergeMap)(function () {
        // We have preloaded file as 30% of the total progress bar. this is not 100% accurate.
        var sum = store.value.loader.progress * 0.7 + store.value.loader.preProgress * 0.3;

        // need to make sure we have the target for the loader. If loader is not showing/disabled this is null.
        if (_this.pbElement) _this.pbElement.style.width = sum + "%";
        return _rxjs.EMPTY;
      }));
    });
    _defineProperty(this, "gameReady", function (action$, store) {
      return action$.pipe((0, _reduxObservable.ofType)(_types2.SERVER_CONFIG, _types.LOADING_COMPLETED, _types3.SERVER_GAME_READY), (0, _operators.filter)(function () {
        return store.value.loader.status === _types.LoaderStatus.Completed && !!store.value.config.connectionId && store.value.game.serverGameReady;
      }), (0, _operators.take)(1), (0, _operators.mergeMap)(function () {
        _Core["default"].resize();
        var elem = document.getElementById("loaderOverlay");
        if (_platformService["default"].isDev()) {
          if (elem) {
            _logger["default"].info('Dev mode, skip loader.');
            elem.classList.add("hidden");
            elem.parentNode.removeChild(elem);
          }
        } else if (elem) {
          elem.classList.add("hidden");
          setTimeout(function () {
            elem.parentNode.removeChild(elem);
          }, 2000);
        }
        return (0, _rxjs.of)({
          type: _types3.GAME_READY
        });
      }));
    });
    _defineProperty(this, "loadSoundSprite", function (action$) {
      return action$.pipe((0, _reduxObservable.ofType)(_types.LOAD_SOUND_SPRITE), (0, _operators.mergeMap)(function (a) {
        _Core["default"].loader.loadSoundSprite(a.payload.sound, a.payload.jsonFilePath, a.payload.volume, a.payload.cb);
        return (0, _rxjs.of)();
      }));
    });
    this.pbElement = document.getElementById("bluePB");
  }
  return _createClass(LoaderEpic, [{
    key: "getEpic",
    value: function getEpic() {
      return (0, _reduxObservable.combineEpics)(this.loadEpic, this.preloadEpic, this.startEpic, this.onProgress, this.gameReady, this.loadSoundSprite, this.languageLoading);
    }
  }]);
}();
//# sourceMappingURL=epics.js.map